import Config from '../../config';
import Collection from '../../collection';
import Form from '../../view/form';
import RefBooksModule from "./refbooks.module";
import Type from '../../model/newstype';

import { roleC } from '../../roles';
import { error } from '../../ui/messages'
import { handle } from '../../service/messages';  
import { beginLock, endLock } from '../../loader';
import { hashify } from '../../utils/arrays';





const 
    OPEN_TYPE = 'type-form--popup',
    TOGGLE_BOUND_ORGANIZATIONS = 'type-form--toggle-bound-organizations',
    TOGGLE_BOUND_ROLES = 'type-form--toggle-bound-roles';





export default RefBooksModule.extend( {

    open({ type, original }) {
        this.options.type = type, this.original = original;

        if (!type.id)
            if (this.state().cluster && this.state().cluster.id != -1)
                type.set( 'cluster', this.state().cluster );
            else if (~roleC.indexOf( Config.role() ))
                type.set( 'cluster', Config.cluster() );

        // both views (Orgs & Roles) contain Grid -
        // so we can make preparation in their common parent
        this.options.sorted = new Collection();
        this.options.filtered = new Collection();
        this.options.resulted = new Collection();

        return this.reSortGrid()
            .then( () => this.reFilterGrid() )
            .then( () => this.bind( type ) );
    },

    onBind() {
        // rewrite originalModel with passed value
        this.originalModel = this.original || this.originalModel;
    },

    start() {
        this.listenTo( this.options.type, 'change:cluster', () => {
            this.setState( { page: 1, } ), this.navigated();
            this.reFilterGrid( this );

            const { type } = this.options;
            if (!type.get( 'group_id' ))
                return;

            const cluster = type.get( 'cluster' );
            const [typeGroup] = this.options.typeGroups.toJSON()
                    .filter( tg => tg.id == type.get( 'group_id' ) );

            if (!!cluster !== !!typeGroup.cluster)
                this.model.set( 'group_id', null );

            if (typeGroup.cluster)
                if (typeGroup.cluster.id != cluster.id)
                    this.model.set( 'group_id', null );
        } );
        this.listenTo( this.options.type, 'change',
            () => this.$( '.-save' )[0].disabled = !this.hasDiff() );

        return this;
    },

    stop() {
        return this.stopListening( this.options.type ), this;
    },

    serialize() {
        const { typeGroups, clusters, } = this.options;

        const typeGroupsFn = () => typeGroups
            .toJSON()
            .filter( tg => !tg.cluster && !this.model.get( 'cluster' ) ||
                tg.cluster && this.model.get( 'cluster' ) &&
                    this.model.get( 'cluster' ).id == tg.cluster.id )
            .map( tg => ({ id: tg.id, title: tg.name }) );

        return {
            typeGroupsFn, clusters,
            hasDiff: () => this.hasDiff(),
        };
    },

    // copied from form.js
    diff(options = {}) {
        return this.model
            ? this.model.diff( this.originalModel, options )
            : [];
    },

    hasDiff(options = {}) {
        return this.diff( options ).length > 0;
    },

    events: {

        'click .-save'() {
            // cluster may be set only at create
            if (!this.model.id)
                if (this.model.get( 'cluster' )) {
                    const clusterId = this.model.get( 'cluster' ).id;
                    const clusterIds = hashify( this.options.organizations,
                        org => [org.id, org.cluster_id] );

                    this.model.set( 'departments', this.model.get( 'departments' )
                        .filter( orgId => clusterId == clusterIds[orgId] ) );
                }

            beginLock( this );

            // dirty hack to force types.save() to invoke save(view) in actions.js
            const stubView = new Form();
            stubView.model = adjustAttrsBeforeSave( this.model, this.options.roles );
            stubView.originalModel = this.originalModel;
            
            return this.options.types.save( stubView ).then( 

                (/*type*/) => this.trigger( RefBooksModule.BACK ), 

                message => {
                    endLock( this );
                    handle( this, error( message ) );
                } );
        },

        'click .-close'() {
            this.trigger( RefBooksModule.BACK );
        },

    },

    [RefBooksModule.event(':bound-organizations:toggle')]() {
        this.trigger( TOGGLE_BOUND_ORGANIZATIONS,
            this.model,
            this.originalModel,
            this.state() );
    },

    [RefBooksModule.event(':bound-roles:toggle')]() {
        this.trigger( TOGGLE_BOUND_ROLES,
            this.model,
            this.originalModel,
            this.state() );
    },

}, {

    OPEN_TYPE,

    TOGGLE_BOUND_ORGANIZATIONS,

    TOGGLE_BOUND_ROLES,

} );






function adjustAttrsBeforeSave(type, roles) {
    const {
        role_ids, __all_roles_available, 
        ...other
    } = type.toJSON();

    const rolesById = hashify( roles, role => [role.id, role] );

    const filteredRoleIds = role_ids == null ? role_ids : role_ids
        .filter( id => {
            const role = rolesById[id];
            // no access to role -> must preserve
            if (!role)
                return true;

            // global type is ok for any role
            return !other.cluster ||
                // global role is ok for any type
                !role.cluster || 
                // otherwise cluster must match
                role.cluster.id == type.get( 'cluster' ).id;
        } );

    const json = {
        role_ids: __all_roles_available
            ? null
            : filteredRoleIds,
        ...other
    };

    return new Type( json );
}


// WEBPACK FOOTER //
// ./src/js/module/refbooks/types.form.template.js